<div class="d-flex flex-wrap mb-2">
    <div class="info-card">
        <div class="card-title">{{ "Last Yestarday Sale (Qty in KG)" }}</div>
        <div class="card-value">{{ previous7Days + ' lakh'}}</div>
        <div class="card-chart">
            <canvas #miniChart1 class="mini-chart" height="0"></canvas>
        </div>
        <div class="card-change" [class.positive]="yesterday_percentage_change_is_up" [class.negative]="!yesterday_percentage_change_is_up">
            <span class="arrow">{{ yesterday_percentage_change_is_up ? '▲' : '▼' }}</span> {{ yesterday_percentage_change }}
             <span class="subtext" style="font-weight:400; font-size:1em; color: black;" >{{ "Previous Sale" }} : {{dayAfterYesterdaySale}} on {{ dayAfterYesterdaySaleDate }}</span>
        </div>
    </div>
    <div class="info-card">
        <div class="card-title">{{ "Last 15 Day Sale (Qty in KG)" }}</div>
        <div class="card-value">{{previous15Days }}</div>
        <div class="card-chart">
            <canvas #miniChart2 class="mini-chart" height="0"></canvas>
        </div>
        <div class="card-change" [class.positive]="last_15_days_percentage_change_is_up" [class.negative]="!last_15_days_percentage_change_is_up">
            <span class="arrow">{{ last_15_days_percentage_change_is_up ? '▲' : '▼' }}</span> {{ last_15_days_percentage_change }}
            <span class="subtext" style="font-weight:400; font-size:1em; color: black;">{{ "Previous 15 Day Sale" }} :{{FIFTEENdays}} on {{ dayAfterYesterdaySaleDate }}</span>
        </div>
    </div>

    <div class="info-card">
        <div class="card-title">{{ "Highest Day Sale (Qty in KG)" }}</div>
        <div class="card-value">{{ firstHighestDaySale }}</div>
        <div class="card-chart">
            <canvas #miniChart3 class="mini-chart" height="0"></canvas>
        </div>
        <div class="card-change" [class.positive]="highest_day_percentage_change_is_up" [class.negative]="!highest_day_percentage_change_is_up">
            <span class="arrow">{{ highest_day_percentage_change_is_up ? '▲' : '▼' }}</span> {{ highest_day_percentage_change }}
            <span class="subtext" style="font-weight:400; font-size:1em; color: black;">{{ "Previous Highest Day Sale" }}: {{ secondHighestDaySale }} on {{ secondHighestDaySaleDate }}</span>
        </div>
    </div>


    <div class="info-card">
        <div class="card-title">{{ "Total FY 25-26 Sale (Qty in KG)" }}</div>
        <div class="card-value">{{ TotalHighfyi }}</div>
        <div class="card-chart">
            <canvas #miniChart4 class="mini-chart" height="0"></canvas>
        </div>
        <div class="card-change" [class.positive]="true" [class.negative]="false">
            <span class="arrow">{{ true ? '▲' : '▼' }}</span> {{ total_qty_percentage_change }}
            <span class="subtext" style="font-weight:400; font-size:1em; color: black;" >{{ "Previous FY 24-25 Sale" }}</span>
    </div>
</div>